// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3IjlG","legacyBtn":"MutateMid_legacyBtn__2KIaQ"};